import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ServerService } from '../../service/server/server.service';
import { ModulesComponent } from '../../service/modules/modules.component';
import { MessageService } from '../../service/message/message.service';

@Component({
  selector: 'app-insert',
  templateUrl: './insert.component.html',
  styleUrls: ['./insert.component.scss']
})
export class InsertComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem("user_info"));
  public lang: any = localStorage.getItem("lang");
  public user_id: number = this.user_info.user_id;
  public loading: boolean = false;
  public subscription: Subscription | any;
  public form1_group: FormGroup | any;
  public server!: any;
  public device!: number;
  public brand!: number;
  public model!: number;
  public creator!: number;
  public service!: string;
  public group!: number;
  public cost_group!: number;
  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<InsertComponent>) {
    this.server = this.serverService.get_server();

    if (dialog_data) {
      this.device = dialog_data.device;
      this.group = dialog_data.group;
      this.creator = dialog_data.creator;
      this.service = dialog_data.service;
      this.cost_group = dialog_data.cost_group
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.create_form();
  }
  create_form() {
    this.form1_group = new FormGroup({
      'title': new FormControl(null, Validators.required),
      'title2': new FormControl(null),
      'cost': new FormControl(null),
      'comment': new FormControl(null),
    })
  }
  save() {
    var address;
    if (this.service == 'brand') { this.insert_brand(); }
    if (this.service == 'device') { this.insert_device(); }
    if (this.service == 'device_status') { this.insert_device_status(); }
    if (this.service == 'cate') { this.insert_cate(); }
    if (this.service == 'group') { this.insert_group(); }
    if (this.service == 'income') { this.insert_income(); }
    if (this.service == 'cost') { this.insert_cost(); }
    if (this.service == 'costs') { this.insert_costs(); } // مربوط به هزینه های فاکتورهای فروش
    if (this.service == 'services') { this.insert_services(); } // مربوط به خدمات فاکتورهای فروش
    if (this.service == 'weight') { this.insert_weight(); }
  }
  insert_brand(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6272
      , 'creator': this.creator
      , 'user_id': this.user_id
      , 'device': this.device
      , 'status_id': 1
      , 'title': this.form1_group.value.title
      , 'title2': this.form1_group.value.title2,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_group(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6342, creator: this.creator, user_id: this.user_id, status_id: 1,
      title: this.form1_group.value.title,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_cost(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6434,
      creator: this.creator,
      user_id: this.user_id,
      status_id: 1,
      title: this.form1_group.value.title,
      cost_group: this.cost_group,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_costs(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 7147,
      creator: this.creator,
      user_id: this.user_id,
      status_id: 1,
      title: this.form1_group.value.title,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_services(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 7163,
      creator: this.creator,
      user_id: this.user_id,
      status_id: 1,
      title: this.form1_group.value.title,
      cost: this.form1_group.value.cost,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_weight(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 7200,
      creator: this.creator,
      user_id: this.user_id,
      status_id: 1,
      title: this.form1_group.value.title,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_income(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6428, creator: this.creator, user_id: this.user_id, status_id: 1,
      title: this.form1_group.value.title,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_device(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6273, creator: this.creator, user_id: this.user_id, status_id: 1,
      title: this.form1_group.value.title,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_device_status(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6465, creator: this.creator, user_id: this.user_id, status_id: 1,
      title: this.form1_group.value.title,
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  insert_cate(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1_group.valid) {
      return false;
    }
    var obj = {
      address: 6274, creator: this.creator, user_id: this.user_id, status_id: 1,
      title: this.form1_group.value.title, group: this.group
    }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['num'] == 1) {
            this.matDialogRef.close(res['result'][0]);
          }
        }//end if
        else if (res['status'] == 4) {
          this.message(true, this.messageService.repeat(), 1, this.messageService.close());

        }
        else {
          this.message(true, this.messageService.erorr_in_load(), 1, this.messageService.close());

        }
      }
    )
  }
  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, creator: this.creator }
    });

    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {

        }
      }
    )
  }
  reset_input(id: number) {

  }
  close() {
    this.matDialogRef.close();
  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}
